module.exports = __webpack_public_path__ + "static/media/plus-key.f36fd2af.svg";